import { useState } from "react";
import { NavLink as NavLinkRRD, Link, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import Cookies from "universal-cookie";
import routesInspector from "routesInpector";
import routesTaller from "routesTaller";
import routesCoordinador from "routesCoordinador";
import routesAuxiliarUT from "routesAuxiliarUT";
import routesConsultas from "routesConsultas";
import routesDistribuidor from "routesDistribuidor";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const cookie = new Cookies();
  const location = useLocation();

  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const toggleSubMenu = (index) => {
    setOpenSubMenu((prevIndex) => (prevIndex === index ? null : index));
  };
  const cerrar = (e) => {
    e.preventDefault(e);
    cookie.remove("id", { path: "/" });
    cookie.remove("usuario", { path: "/" });
    cookie.remove("nombre", { path: "/" });
    cookie.remove("regionalId", { path: "/" });
    cookie.remove("tipoUsuarioId", { path: "/" });
    cookie.remove("tallerId", { path: "/" });
    cookie.remove("tallerSeleccionado", { path: "/" });

    window.location.href = "/auth/login";
  };
  const createLinks = (routes) => {
    return routes
      .filter((prop) => !prop.hidden) // <-- Agregado para omitir rutas ocultas
      .map((prop, key) => {
        if (prop.routes) {
          // If the route contains sub-routes, render a dropdown
          return (
            <NavItem key={key}>
              <NavLink
                href="#"
                onClick={() => toggleSubMenu(key)}
                className="d-flex align-items-center justify-content-between"
              >
                <span>
                  <i className={prop.icon} />
                  {prop.name}
                </span>
                <i
                  className={`ni ${
                    openSubMenu === key ? "ni-bold-down" : "ni-bold-right"
                  }`}
                />
              </NavLink>
              <Collapse isOpen={openSubMenu === key}>
                <Nav navbar className="pl-4">
                  {createLinks(prop.routes)}
                </Nav>
              </Collapse>
            </NavItem>
          );
        } else {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                activeClassName="active"
              >
                <i className={prop.icon} />
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }
      });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        {/* Collapse */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                    src={require("../../assets/img/theme/logofot.png")}
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">{cookie.get("nombre")}</h6>
              </DropdownItem>

              <DropdownItem href="#pablo" onClick={cerrar}>
                <i className="ni ni-user-run" />
                <span>Cerrar Sesión</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Search Form */}
          <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>
          <Nav navbar>
            {cookie.get("tipoUsuarioId") == "1"
              ? createLinks(routes)
              : cookie.get("tipoUsuarioId") == "3"
                ? createLinks(routesTaller)
                : cookie.get("tipoUsuarioId") == "2"
                  ? createLinks(routesInspector)
                  : cookie.get("tipoUsuarioId") == "4"
                    ? createLinks(routesCoordinador)
                    : cookie.get("tipoUsuarioId") == "5"
                      ? createLinks(routesAuxiliarUT)
                      : cookie.get("tipoUsuarioId") == "6"
                        ? createLinks(routesConsultas)
                        : cookie.get("tipoUsuarioId") == "7"
                          ? createLinks(routesDistribuidor)
                          : null}
          </Nav>
          {/* Divider */}
          <hr className="my-3" />
          {/* Additional nav items */}
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
